import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { OccEndpointsService } from '@spartacus/core';
import { Subject, Observable, BehaviorSubject } from 'rxjs';
import { CookieService } from 'src/app/customServices/cookie.service';

@Injectable({
  providedIn: 'root'
})
export class KbCompareService {
  compareData: any[] = [];
  //data 
  dataSubject = new BehaviorSubject<any[]>(null);
  data$: Observable<any[]> = this.dataSubject.asObservable();
  // to uncheck 
  private _shouldUncheckCheckbox = new BehaviorSubject<number>(0);
  shouldUncheckCheckbox$ = this._shouldUncheckCheckbox.asObservable();
  //for hiding comparefooter in compare page alone
  private _isOpen = new BehaviorSubject<boolean>(true);
  canShow$ = this._isOpen.asObservable();
  constructor(private http: HttpClient, 
    private occService:OccEndpointsService,
    private Session:CookieService) { }
    
  //method to show and hide the footer content
  canOpen(message: boolean) {
    this._isOpen.next(message);
  }
   // to set a state as a array
  setData(newData: any, isSelected): void {
    if (isSelected) {
      this.compareData.push(newData);
      this.dataSubject.next([this.compareData]);
    } else {
      this.removeElementById(newData.code);
    }
  }
   // the get data fro the api call for compare page
   getCompareProdsApiCall(productCode){
    return this.http.get(this.occService.buildUrl(`products/compare?productCode=${productCode}`))
   }
   // to remove specific product alone by Id
  removeElementById(idToRemove: number) {
    this._shouldUncheckCheckbox.next(idToRemove);
    this.compareData = this.compareData.filter((item) => item.code !== idToRemove);
    this.dataSubject.next([this.compareData]);

  }
  //to remove all by clear all button
  deleteAllInCompare() {
    this.compareData.length = 0;
    this.dataSubject.next([this.compareData]);
    this.Session.removeItemSessionStorage('prdCodes');
    this._shouldUncheckCheckbox.next(0);
  }
  //configuring data to make api and storing it in local
  storeDataToMakeApiCall(){
    //this.Session.removeItemSessionStorage('prdCodes');
    const prodData = this.compareData;
    const apiCallProductCode = [];
    if (prodData.length !== 0) {
     // this.showContent = true;
      prodData.map((x) => {
        apiCallProductCode.push(x.code);
      })
      const Prdcodes = JSON.stringify(apiCallProductCode);
      const result = Prdcodes.replace(/^\[|\]$/g, '').replace(/"/g, '');
      this.Session.setItemSessionStorage('prdCodes',result);

    }
  }
  //changing the state of the Array in local when api call is made 
  //storing the data from api call
  putNewArrayFromApi(prodData:any){
    this.compareData.length = 0;

    this.compareData = [...prodData];
    this.dataSubject.next([this.compareData]);
  }
}
